export const changeCity = (t) =>{
    return({
        type: "CHANGE_CITY",
        payload: t,
    });
}
